<template>
  <!-- It would be slightly better to use a table element with a caption here, however comark cannot unwrap table elements --->
  <figure class="figure">
    <slot />
    <figcaption class="figure-caption">
      {{ props.caption }}
    </figcaption>
  </figure>
</template>

<script setup lang="ts">
const props = defineProps({
  caption: {
    type: String
  }
})
</script>
